import { repository } from 'redux-scaffolding-ts';
import { DataStore } from 'stores/dataStore';
import { ValidationResult } from 'fluent-ts-validator';

export interface ChecklistMetricDto {
  eventType: string;
  completionRate: number;
}

@repository('@@CHECKLIST_METRICS', 'checklistMetrics.list')
export class ChecklistMetricsStore extends DataStore<ChecklistMetricDto> {
  baseUrl = 'events/v1';
  createPath = '';
  retrievePath = 'get-checklist-metrics';
  updatePath = '';
  deletePath = '';

  protected validate(_: ChecklistMetricDto) {
    return new ValidationResult();
  }

  constructor() {
    super('CHECKLIST_METRICS_LIST', {
      isBusy: false,
      items: [],
      count: 0,
      result: undefined,
      discard: () => {}
    });
  }
}
